module.exports = __webpack_public_path__ + "img/logoBlueFull.2cb8a733.png";